var map = {
	"./1.svg": "2c77",
	"./arrow-right.svg": "2a29",
	"./arrow-shaded.svg": "b504",
	"./breath.svg": "f2d7",
	"./charge-hight.svg": "40ec",
	"./charge-low.svg": "84e1",
	"./charge-middle.svg": "d957",
	"./clock.svg": "ea63",
	"./connection.svg": "fafb",
	"./connection_off.svg": "712c",
	"./cross-in-circle.svg": "b780",
	"./cross.svg": "2872",
	"./device.svg": "0199",
	"./document.svg": "c47c",
	"./ecg-graph.svg": "790e",
	"./edit-trainings.svg": "5450",
	"./edit_pen_inside_the_square.svg": "9afd",
	"./empty-list.svg": "2069",
	"./expand.svg": "1772",
	"./filter.svg": "f601",
	"./generate.svg": "cbad",
	"./googleplay-dark.svg": "8eaa",
	"./googleplay-en.svg": "3be7",
	"./googleplay-ru.svg": "a56b",
	"./graph.svg": "cfa3",
	"./heart-dark.svg": "16e4",
	"./heart-white.svg": "010a",
	"./heart.svg": "ea3d",
	"./heart_rate.svg": "409f",
	"./interval-hr.svg": "47382",
	"./logging.svg": "73cf",
	"./menu_burger.svg": "6d1b",
	"./menu_grid.svg": "e425",
	"./menu_one_item.svg": "48d3",
	"./menu_three_item.svg": "a4e6",
	"./menu_two_item.svg": "0850",
	"./no-wi-fi.svg": "a96e",
	"./plus.svg": "871b",
	"./protocol.svg": "8f45",
	"./rustore-dark.svg": "752c",
	"./rustore-ru.svg": "40b8",
	"./smartphone.svg": "69c8",
	"./steps.svg": "2986",
	"./steps_fill.svg": "60d5",
	"./tick_inside_the_square.svg": "40f9",
	"./undo_inside_the_square.svg": "8ba3",
	"./warning.svg": "10f5",
	"./wi-fi-no.svg": "8294",
	"./wi-fi.svg": "c26e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7906";